<template>
  <div class="delegate">
    <h2>{{ $t('hunters.delegate') }}</h2>

    <el-select v-model="hunter" value-key="id" filterable :placeholder="$t('hunters.select')">
      <el-option
        v-for="item in hunters"
        :key="item.id"
        :label="item.profile.name"
        :value="item"
      >
        {{ item.profile.name }}
      </el-option>
    </el-select>

    <ts-hunter :hunter="selected" :editable="false" style="margin-top: 30px" />
  </div>
</template>

<script>
  import Hunter from './Hunter.vue'

  export default {
    components: {
      'ts-hunter': Hunter
    },

    props: {
      selected: Object
    },

    data() {
      return {
        hunter: null
      }
    },

    computed: {
      hunters() {
        return this.$store.state.Hunters.list
      }
    },

    watch: {
      selected() {
        if (this.hunter && this.hunter.id !== this.selected.id) {
          this.hunter = null
        }
      },

      hunter() {
        this.$emit('hunter-change', this.hunter)
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/variables';

  .el-select-dropdown__item {
    font-size: 16px!important;
  }

  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background-color: #E3E3E3!important;
  }

  .delegate {
    padding-top: 50px;

    .el-select {
      margin-top: 30px;
      width: 100%;
    }

    .el-input {
      .el-input__inner {
        padding-left: 0;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
</style>
